// extracted by mini-css-extract-plugin
module.exports = {"root":"SignUpBtn_root__A8GpT","animatedSignupBtn":"SignUpBtn_animatedSignupBtn__P5P4x"};